
import { useEffect, useState } from "react";
import { api } from "../../../../utils/api";
import Paginator from "../../../common/paginator/Paginator";
import { ProfileEmpty, ProfileSection, ProfileSectionError } from "../common/ProfileSection";
import Discussion from "./Discussion";

export default function DiscussionSection({ isDesktop, profileId }) {
	const [discussions, setDiscussions] = useState([]);
	const [page, setPage] = useState(1);
	const [maxPageNum, setMaxPageNum] = useState(1);
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");

	useEffect(() => {
		fetchDiscussions();
	}, []);

	useEffect(() => {
		fetchDiscussions();
	}, [page]);

	function fetchDiscussions() {
		if (isLoading) {
			return;
		}
		setIsLoading(true);
		let pageParam = page ? page : 1;
		api.discussionListByProfile({
			profile_id: profileId,
			page: pageParam,
		})
			.then((result) => {
				setDiscussions(result["discussions"]);
				setMaxPageNum(result["max_page"]);
				setIsLoading(false);
			})
			.catch((err) => {
				setIsLoading(false);
				if (err && err.data) {
					setErrorMessage(err.data.message);
				}
			});
	}

	return (
		<ProfileSection title="تالار">
			{discussions.length >= 1 ? (
				<div className={`grid gap-4 ${isDesktop ? "grid-cols-3" : "grid-cols-1"}`}>
					{discussions.map((discussion) => (
						<Discussion key={discussion.id} discussion={discussion} />
					))}
				</div>
			) : (
				<ProfileEmpty>گفتگویی وجود ندارد</ProfileEmpty>
			)}
			{discussions.length >= 1 && maxPageNum >= 2 && (
				<div className="flex justify-center mt-5">
					<Paginator
						currentPage={page}
						maxPageNum={maxPageNum}
						isLoading={isLoading}
						onChange={(newPage) => {
							setPage(newPage);
						}}
					/>
				</div>
			)}
			<ProfileSectionError message={errorMessage} />
		</ProfileSection>
	);
}
